import {useAppDispatch} from "@/store";
import {setValidations} from "@/store/slices/globaleSlice";
import {signOut} from "next-auth/react";
import {myLinks} from "@/lib/routes/myLinks";
import {useNotification} from "@/lib/hook/useNotification";

export const useResponseValidate = () => {
    const dispatch = useAppDispatch()
    const send = useNotification()

    const successValidate = (resp) =>{
        if (resp && resp.message){
            send({
                type: 'success',
                description: resp.message,
            })
        }
    }

    const errorValidate = (error, formName) =>{
        if (error && error.response){
            switch (error.response.status){
                case 401:
                    signOut({callbackUrl: myLinks.getUlr('sign-in')})
                    break
                case 404:
                    //dispatch(setErrorMessage('URL не найден'))
                    break
                case 422:
                    dispatch(setValidations({
                        errors: error.response.data.errors,
                        formName
                    }))
                    let resp = 'Некорректные данные <br/>';
                    {Object.values(error.response.data.errors).forEach((errors)=>{
                        if (Array.isArray(errors)){
                            errors.forEach((item)=>{
                                resp += `${item} <br/>`
                            })
                        }else {
                            resp += `${errors} <br/>`
                        }
                    })}
                    send({
                        type: 'error',
                        description: <div dangerouslySetInnerHTML={{ __html: resp }} />,
                    })
                    break
                default:
                    if (error.response.data.message){
                        send({
                            type: 'error',
                            description: error.response.data.message,
                        })
                    }
            }
        }else {
            // signOut()
            // router.push('/500')
        }
    }

    return {
        successValidate,
        errorValidate
    };
}